<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-form-item label="平台渠道：" class="hide_input">
            <el-radio-group v-model="queryParams.channel">
              <el-radio>全部</el-radio>
              <el-radio :label="1">亚马逊</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="店铺名称：" class="hide_input">
            <el-radio-group v-model="queryParams.shop_name">
              <el-radio>全部</el-radio>
              <el-radio :label="1">xowvo9a2@163.com 家居1_MY</el-radio>
              <el-radio :label="2">Scoinhouse_SG</el-radio>
              <el-radio :label="3">Scoinhouse_TH</el-radio>
              <el-radio :label="4">Scoinhouse_ID</el-radio>
              <el-radio :label="5">Scoinhouse_PH</el-radio>
              <el-radio :label="6">Famebaby_ID</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="导入时间：">
            <el-date-picker
              size="small"
              v-model="queryParams.time"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
            >
            </el-date-picker>

            <el-button size="small" style="margin-left: 10px" type="primary">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="success" size="small" @click="importFileVisible = true">导入订单文件</el-button>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="导入编号" prop="importId"></el-table-column>
        <el-table-column label="导入时间" prop="ctime"></el-table-column>
        <el-table-column label="导入店铺" prop="shop"></el-table-column>
        <el-table-column label="导入订单数" prop="order_num"></el-table-column>
        <el-table-column label="导入状态" prop="status"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDownload(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
    <el-dialog :close-on-click-modal="false"   title="导入订单文件" :visible.sync="importFileVisible">
      <div>
        <el-form ref="fileForm" :model="fileForm" label-width="100px">
          <el-form-item label="选择店铺：" required>
            <el-select clearable  size="small" v-model="fileForm.shop">
              <el-option label="1" value="1">1</el-option>
              <el-option label="2" value="2">2</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择文件：">
            <el-upload action="https://jsonplaceholder.typicode.com/posts/" :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="importFileVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="importFileVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pageSize: 30,
        pageNum: 1,
      },
      importFileVisible: false,
      fileForm: {},
      total: 0,
      loading: false,
      tableData: [
        {
          importId: 322111,
          ctime: '2021-04-10 23:22:21',
          shop: 'lnnhbt@163.com',
          order_num: 4,
          status: '导入成功',
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /* 获取列表数据 */
    loadData() {
      this.total = 1;
    },
    /* 下载数据 */
    handleDownload(row) {},
  },
};
</script>

<style lang="scss" scoped></style>
